// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21","divider":"SeenBlock__divider___3SCWN","gm-style-iw":"SeenBlock__gm-style-iw___3HpvI","seenBlock":"SeenBlock__seenBlock___cOdb6","seenBlockWrapper":"SeenBlock__seenBlockWrapper___2bK7g","seenBlockItem":"SeenBlock__seenBlockItem___PtYx_","seenBlockItemTextBlock":"SeenBlock__seenBlockItemTextBlock___3lDK9","itemName":"SeenBlock__itemName___24MCE","itemDescription":"SeenBlock__itemDescription____OJmY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SeenBlock/SeenBlock.scss
 ** module id = 1347
 ** module chunks = 0
 **/